module.exports = "//static.hsappstatic.net/salesImages/static-1.403/dynamiccta/read-article.svg"